import { render, staticRenderFns } from "./PortalTopBar.vue?vue&type=template&id=4ff8140f&scoped=true&"
import script from "./PortalTopBar.vue?vue&type=script&lang=js&"
export * from "./PortalTopBar.vue?vue&type=script&lang=js&"
import style0 from "./PortalTopBar.vue?vue&type=style&index=0&id=4ff8140f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff8140f",
  null
  
)

export default component.exports